import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { MapPinIcon, UsersIcon, CalendarIcon, StarIcon } from 'lucide-react';
const bars = [{
  name: 'The Throttle Stop',
  location: 'Detroit, MI',
  description: 'Classic biker bar with live music on weekends. Great burgers and cold beer. Bike nights every Thursday.',
  vibe: 'Classic & Loud'
}, {
  name: 'Iron Horse Saloon',
  location: 'Grand Rapids, MI',
  description: 'Friendly atmosphere with a huge parking lot for bikes. Known for their bike shows and charity rides.',
  vibe: 'Community Hub'
}, {
  name: 'Saddlebag Tavern',
  location: 'Traverse City, MI',
  description: 'Up north favorite near the Tunnel of Trees. Perfect stop after a scenic ride. Great local craft beers.',
  vibe: 'Scenic Stop'
}, {
  name: 'Chrome & Steel',
  location: 'Flint, MI',
  description: 'No-frills biker bar with pool tables and darts. Welcoming to all riders. Cheap drinks, good times.',
  vibe: 'Dive Bar'
}, {
  name: 'Lakeside Roadhouse',
  location: 'St. Ignace, MI',
  description: 'Gateway to the UP with waterfront views. Popular meetup spot for riders heading to Copper Harbor.',
  vibe: 'Waterfront'
}];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0
  }
};
export function BikerBars() {
  return <div className="min-h-screen bg-[#0a0a0a] safe-bottom" data-id="element-81">
      <PageHeader title="Great MI Biker Bars" subtitle="Community spots for Michigan riders" data-id="element-82" />

      <main className="px-4 py-6" data-id="element-83">
        <motion.div className="space-y-4" variants={container} initial="hidden" animate="show" data-id="element-84">
          {bars.map((bar, index) => <motion.div key={index} variants={item} className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-2xl p-4" data-id="element-85">
              <div className="flex items-start justify-between mb-3" data-id="element-86">
                <div data-id="element-87">
                  <h3 className="font-bold text-white mb-1" data-id="element-88">{bar.name}</h3>
                  <div className="flex items-center gap-1 text-[#a3a3a3]" data-id="element-89">
                    <MapPinIcon className="w-3 h-3" data-id="element-90" />
                    <span className="text-xs" data-id="element-91">{bar.location}</span>
                  </div>
                </div>
                <div className="bg-[#a855f7]/10 px-2 py-1 rounded-lg" data-id="element-92">
                  <span className="text-xs text-[#a855f7] font-medium" data-id="element-93">
                    {bar.vibe}
                  </span>
                </div>
              </div>
              <p className="text-[#a3a3a3] text-sm leading-relaxed" data-id="element-94">
                {bar.description}
              </p>
            </motion.div>)}
        </motion.div>

        {/* Disclaimer */}
        <motion.div className="mt-6 bg-[#252525] rounded-2xl p-4" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.6
      }} data-id="element-95">
          <p className="text-[#a3a3a3] text-xs leading-relaxed" data-id="element-96">
            <span className="text-white font-medium" data-id="element-97">Ride Responsibly:</span>{' '}
            Never drink and ride. Michigan has strict DUI laws for
            motorcyclists. Designate a sober rider or use a trailer service.
          </p>
        </motion.div>

        {/* Community Note */}
        <motion.div className="mt-4 bg-[#d4a853]/10 border border-[#d4a853]/30 rounded-2xl p-4" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.7
      }} data-id="element-98">
          <div className="flex items-center gap-2 mb-2" data-id="element-99">
            <UsersIcon className="w-5 h-5 text-[#d4a853]" data-id="element-100" />
            <p className="text-[#d4a853] font-semibold" data-id="element-101">Know a Great Spot?</p>
          </div>
          <p className="text-[#a3a3a3] text-sm" data-id="element-102">
            Contact us to suggest biker-friendly bars and restaurants for our
            community list.
          </p>
        </motion.div>
      </main>
    </div>;
}